module.exports = __webpack_public_path__ + "img/bg.f2312bff.jpg";